<template>
  <main id="clientAccountant" v-if="config.status.authed">
    <Toolbar ref="toolbar"
      :item="getItem"
      @select="update"
    />
    <v-progress-linear indeterminate v-if="isInitializing || isLoading" class="ma-0" color="blue" />
    <v-container fluid grid-list-md
      v-if="!isInitializing"
      class="px-1 py-1"
    >
      <v-layout v-if="!isSetItem">
        <v-flex xs12>
          <p class="headline text-xs-center grey--text">会計がございません。【機能】より会計を追加してください。</p>
        </v-flex>
      </v-layout>
    </v-container>
    <div id="legacy" v-if="isSetItem">
      <iframe ref="legacyFrame" name="legacyFrame" src="" @load="onLoad"></iframe>
      <form id="legacyForm" ref="legacyForm" target="legacyFrame" :action="printURL" method="POST">
        <input type="hidden" name="firebaseToken" ref="legacyToken" value="" />
      </form>
    </div>
  </main>
</template>

<script>
import Toolbar from './toolbar'
export default {
  name: 'clientAccountantLegacy',
  components: {
    Toolbar,
  },
  data () {
    return {
      config: {
        status: {
          authed: false,
          loading: false,
          active: true
        }
      },
      meta: {
      },
      store: {
        item: null
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    onLoad: function (e) {
      if (this.$refs.toolbar) {
        this.$refs.toolbar.get()
      } else {
        setTimeout(this.onLoad, 1000)
      }
    },
    init: function () {
      this.auth()
      this.$set(this.config.status, 'active', !this.$vuetify.breakpoint.mdAndDown)
    },
    auth: function () {
      let auths = this.$store.getters['author/get']('authority')
      let permit = this.$route.meta.permit
      if (!auths.includes(permit)) {
        this.$router.push('/')
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    },
    get: function (req) {
      const { id } = req || {}
      const cid = this.$route.params.id
      if (id) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}cbook/get/item/${id}`, { cid }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            this.$set(this.config.status, 'loading', false)
            if (res.data && res.data.success) {
              this.$set(this.store, 'item', Object.assign({}, req, res.data.data))
            }
          })
        }).catch(err => {
          console.log(err)
          this.$set(this.config.status, 'loading', false)
        })
      }
    },
    update: function (req) {
      const { item, forceLoad } = req || {}
      const { id } = item || {}
      const oldItem = this.store.item || { id: '' }
      if (id) {
        this.get(item)
        this.$set(this.store, 'item', item)
        if (oldItem.id !== id || forceLoad) {
          this.$firebase.auth().currentUser.getIdToken(true).then(token => {
            this.$refs.legacyToken.value = token
            this.$nextTick(() => {
              this.$refs.legacyForm.submit()
            })
          })
        }
      } else {
        this.$set(this.store, 'item', {})
        this.$set(this.config.status, 'loading', false)
      }
      // if (req && req.id) {
      //   this.$set(this.store, 'item', req)
      //   this.$firebase.auth().currentUser.getIdToken(true).then(token => {
      //     this.$refs.legacyToken.value = token
      //     this.$nextTick(() => {
      //       this.$refs.legacyForm.submit()
      //     })
      //   })
      // } else {
      //   this.$set(this.store, 'item', {})
      // }
    }
  },
  computed: {
    isDeveloping () {
      return this.$store.getters['author/get']('dev')
    },
    isInitializing () {
      return this.store.item == null
    },
    isLoading () {
      return this.config.status.loading
    },
    isSetItem () {
      return (this.store.item && this.store.item.id)
    },
    getItem () {
      return this.store.item
    },
    getChildren () {
      return this.store.item && this.store.item.items && this.store.item.items.filter(item => item.type !== 'charges').map((item, idx) => {
        const itemType = this.meta.types[`${item.type}-${item.label}`] ? `${item.type}-${item.label}` : item.type
        const balance = this.store.item.items.filter(item => item.type !== 'charges').slice(0, idx + 1).reduce((pre, current) => {
          const { type, sum, label } = current
          if (this.meta.types[type]) {
            return this.meta.types[type].sign === 'negative' ? (pre - sum) : (pre + sum)
          } else if (this.meta.types[`${type}-${label}`]) {
            return this.meta.types[`${type}-${label}`] ? (pre - sum) : (pre + sum)
          } else {
            return pre + sum
          }
        }, 0)
        return {
          ...item,
          date: {
            value: item.date,
            text: this.$moment(item.date).format('YYYY年MM月DD日')
          },
          type: [
            {
              value: itemType,
              text: this.$mango.bbook.items[itemType] || itemType
            },
            this.$mango.bbook.types[item.label] && {
              value: item.label,
              text: this.$mango.bbook.types[item.label] || item.label
            }
          ],
          sum: {
            value: item.sum,
            text: `¥${item.sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
          balance: {
            value: balance,
            text: `¥${balance}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          }
        }
      })
    },
    hasCharges () {
      return this.store.item && this.store.item.charges && this.store.item.charges.length      
    },
    getCharges () {
      return this.store.item && this.store.item.charges && this.store.item.charges.length && this.store.item.charges.map(it => {
        return {
          ...it,
          children: it.children.length ? it.children.map(child => {
            return {
              ...child,
              label: {
                value: child.label,
                text: this.$mango.bbook.types[child.label] || child.label
              },
              sum: {
                value: child.sum,
                text: `¥${child.sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
              }
            }
          }) : [],
          date: {
            due: {
              value: it.date,
              text: this.$moment(it.date).format('YYYY/MM/DD')
            },
            charged: {
              value: it.children[0] && it.children[0].date,
              text: it.children[0] && this.$moment(it.children[0].date).format('YYYY/MM/DD')
            }
          },
          sum: {
            value: it.sum,
            text: `¥${it.sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          }
        }
      })
    },
    printURL () {
      let uid = (this.store.item && this.store.item.id) ? this.store.item.id.replace('cbook_', '').toUpperCase() : ''
      let cid = this.$route.params.id
      return `https://legacy.sasmango.com/sas/client/${cid}/cbook${(uid ? ('/' + uid) : '')}`
    }
  }
}
</script>

<style lang="scss">
.b-item {
  &:hover {
    background-color: #E0EAF0;
  }
}
.v-list-group {
  .v-list-group__header {
    padding: 0 !important;
  }
  .v-list-item__subtitle {
    font-size: .7rem !important;
  }
}
#clientAccountant {
  #legacy {
    width: 100%;
    height: 100%;
    iframe {
      display: block;
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}
</style>
